import { render, staticRenderFns } from "./RemoveAppointmentModal.vue?vue&type=template&id=572a2be5"
import script from "./RemoveAppointmentModal.vue?vue&type=script&lang=js"
export * from "./RemoveAppointmentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports